import { LIST_CONTROL_QUESTION_COMMON } from 'constants';
import { LIST_CONTROL_QUESTION } from 'constants';

import { useRef, useState } from 'react';

import { Switch } from 'antd';

import Input from 'components/Input';
import { ENUM_QUESTION_TYPE } from 'constants/enum';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';
import { useClickOutside } from 'hooks/useClickOutside';

const ContentCopy = require('assets/resources/ContentCopy.svg').default;
const DeleteOutline = require('assets/resources/DeleteOutline.svg').default;
const MoreVert = require('assets/resources/MoreVert.svg').default;

const FooterQuestion = (props) => {
  const { questionIndex, data, section, handleRequiredQuestion, handleDuplicateQuestion, handleDeleteQuestion, handleControlQuestion } = props;

  const [controlQuestionOpen, setControlQuestionOpen] = useState(false);
  const controlQuestionRef = useRef(null);

  useClickOutside(controlQuestionRef, () => {
    setControlQuestionOpen(false);
  });

  const onChangeRequiredQuestion = (value) => {
    handleRequiredQuestion(section.id, questionIndex, value);
  };

  const onDuplicateQuestion = (e) => {
    e.stopPropagation();
    handleDuplicateQuestion(section.id, questionIndex);
  };

  const onDeleteQuestion = (e) => {
    e.stopPropagation();
    handleDeleteQuestion(section.id, data.id);
  };

  return (
    <div className="flex items-center justify-end gap-4 pt-4">
      <div className="flex items-center gap-2">
        <label htmlFor="required" className="text-black-102">
          {TEXT_CREATE_SURVEY.MUST}
        </label>
        <Switch size="small" checked={data.is_required} onChange={onChangeRequiredQuestion} />
      </div>
      <div className="h-6 border-r border-solid border-black/6"></div>
      <img onClick={onDuplicateQuestion} className="cursor-pointer" src={ContentCopy} alt="copy content" width={24} height={24} />
      <img onClick={onDeleteQuestion} className="cursor-pointer" src={DeleteOutline} alt="delete outline" width={24} height={24} />
      <div className="relative" ref={controlQuestionRef}>
        <div className={`control-question absolute w-33 py-1 bg-white shadow-soft-md animation-top ${controlQuestionOpen && 'show'}`}>
          <label className="text-xs text-black-102 px-3">{TEXT_CREATE_SURVEY.EXPRESS}</label>

          {(data.question_type === ENUM_QUESTION_TYPE.DATE ? LIST_CONTROL_QUESTION : LIST_CONTROL_QUESTION_COMMON).map((item, index) => (
            <div
              key={`control-question-${index}`}
              className={`flex items-center gap-2 opacity-85 px-3 py-2.5 ${(data?.active_checkbox || [])?.indexOf(item.value) === -1 ? '' : 'bg-teal-732'}`}
            >
              <Input
                onChange={() => {
                  handleControlQuestion(section.id, questionIndex, item.value);
                }}
                checked={(data?.active_checkbox || [])?.indexOf(item.value) === -1 ? false : true}
                type="checkbox"
                className="w-4 h-4 flex items-center checkbox-button"
                classNameInput="w-4 h-4 border-0 bg-transparent border-b border-dashed !border-gray-102/65 text-gray-102/65 !p-0 accent-primary-346 cursor-pointer"
              />
              <label className={`text-sm ${(data?.active_checkbox || [])?.indexOf(item.value) === -1 ? 'text-black-102' : 'text-primary-346'}`}>
                {item.text}
              </label>
            </div>
          ))}
        </div>
        <img
          onClick={() => setControlQuestionOpen(!controlQuestionOpen)}
          className="cursor-pointer"
          src={MoreVert}
          alt="more vert"
          width={24}
          height={24}
        />
      </div>
    </div>
  );
};

export default FooterQuestion;
